$(document).ready(function(){

	// -- Hamburger --
	$('.btn--menu').on('click', function(){
		$('body').toggleClass('mainMenu--open');
		$(this).toggleClass('is-active');
	});

});